import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';

import { combineLatest, Observable, map } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';

import { BreadcrumbItem, heroBackgroundTextClass } from '../../../interfaces';
import { BreadcrumbService, NavigationMenuService } from '../../../services';

@Component({
  selector: 'fin-breadcrumb',
  styleUrls: ['./breadcrumb.component.scss'],
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  private languageService = inject(LanguageService);
  private navigationMenuService = inject(NavigationMenuService);
  private breadcrumbService = inject(BreadcrumbService);

  readonly currentLanguage$: Observable<string>;

  readonly textClass = computed(() => heroBackgroundTextClass(this.breadcrumbService.heroBackground()));
  breadcrumbItems$: Observable<BreadcrumbItem[]>;
  currentPath$: Observable<string>;

  constructor() {
    this.currentLanguage$ = this.languageService.lang;
  }

  ngOnInit(): void {
    const serviceBreadcrumb$ = this.breadcrumbService.breadcrumb$;
    const isLandingPage$ = this.navigationMenuService.isLandingPage$;

    this.currentPath$ = this.navigationMenuService.currentPath$;
    this.breadcrumbItems$ = combineLatest([serviceBreadcrumb$, isLandingPage$]).pipe(
      map(([serviceBreadcrumb, isLandingPage]) => {
        return isLandingPage ? [] : serviceBreadcrumb;
      })
    );
  }
}
